export const InitialState = {
  range: "date",
};

export interface salesReportType {
  range: string;
  selectSalesRecord?: (selectTarget: string) => void;
}
